<section
  class="ui-card"
  [class.ui-card-elevated]="elevated()"
  [class.ui-card-padding-none]="hasNoPadding()"
  [class.ui-card-padding-sm]="hasSmallPadding()"
  [class.ui-card-padding-md]="hasMediumPadding()"
>
  <ng-content />
</section>
